import { Modal } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';

import React from 'react';
import CommentDialog from '../../../../_components/comment-dialog/CommentDialog';
import { STATUS_TYPES } from '../../../../constants';

interface IEventModals {
  showConfirmDialog: boolean;
  setShowConfirmDialog: (value: boolean) => void;
  onConfirmCancelDialogueHandler: () => void
  showCommentDialog: boolean;
  setShowCommentDialog: (value: boolean) => void;
  handlePatchEvent: (updateStatus: string, authComm: string) => void
  modalShow: boolean;
  setModalShow: (value: boolean) => void;
  approveModalShow: boolean;
  setApproveModalShow: (value: boolean) => void;
  editModalShow: boolean;
  setEditModalShow: (value: boolean) => void;
  handleEditEventForm: () => void,
  toastMessage: {
    success: (title: string, message: string, timeout?: number | undefined) => void;
    failure: (title: string, message: string, timeout?: number | undefined) => void;
    warning: (title: string, message: string, timeout?: number | undefined) => void;
    renderToast: () => React.JSX.Element;
  }
}

const EventModals = ({ showConfirmDialog, setShowConfirmDialog, onConfirmCancelDialogueHandler, showCommentDialog, setShowCommentDialog, handlePatchEvent, modalShow, setModalShow, approveModalShow, setApproveModalShow, editModalShow, setEditModalShow, handleEditEventForm, toastMessage }: IEventModals) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <Modal
        modalTitle={translate('comment_dialog.lbl_close')}
        modalShow={showConfirmDialog}
        modalBody={translate('comment_dialog.cancel_confirm_msg')}
        btnCloseText={String(translate('comment_dialog.lbl_no'))}
        btnSaveText={String(translate('comment_dialog.lbl_yes'))}
        onCloseModal={() => {
          setShowConfirmDialog(false);
        }}
        onSaveModal={() => {
          onConfirmCancelDialogueHandler();
        }}
        alignToCentre
        disableSaveBtn={false}
        disableCloseBtn={false}
        type="warning"
      />
      <CommentDialog
        label={translate('events_wrapper.lbl_reject')}
        show={showCommentDialog}
        onHide={() => {
          setShowCommentDialog(false);
        }}
        onConfirm={(comment: string) => {
          handlePatchEvent(STATUS_TYPES.REJECTED, comment);
        }}
        subLabel={translate('comment_dialog.comment_event_form_text')}
      />
      {toastMessage.renderToast()}
      <Modal
        modalTitle={translate('events_wrapper.lbl_submit_for_review')}
        modalShow={modalShow}
        type="warning"
        modalBody={String(translate('events_wrapper.msg_send_for_approval'))}
        btnCloseText={String(translate('comment_dialog.lbl_no'))}
        btnSaveText={String(translate('comment_dialog.lbl_yes'))}
        onCloseModal={() => { setModalShow(false); }}
        onSaveModal={() => {
          handlePatchEvent(STATUS_TYPES.PENDING_APPROVAL, '');
          setModalShow(false);
        }}
        alignToCentre
        disableSaveBtn={false}
        disableCloseBtn={false}
      />
      <Modal
        modalTitle={translate('events_wrapper.lbl_approve')}
        modalShow={approveModalShow}
        modalBody={String(translate('events_wrapper.msg_approve'))}
        btnCloseText={String(translate('comment_dialog.lbl_no'))}
        btnSaveText={String(translate('comment_dialog.lbl_yes'))}
        onCloseModal={() => { setApproveModalShow(false); }}
        onSaveModal={() => {
          handlePatchEvent(STATUS_TYPES.APPROVED, '');
          setApproveModalShow(false);
        }}
        alignToCentre
        disableSaveBtn={false}
        disableCloseBtn={false}
        type="warning"
      />
      <Modal
        modalTitle={translate('events_wrapper.lbl_new_version')}
        modalShow={editModalShow}
        modalBody={translate('events_wrapper.msg_new_version')}
        btnCloseText={String(translate('comment_dialog.lbl_close'))}
        btnSaveText={String(translate('comment_dialog.lbl_proceed'))}
        onCloseModal={() => { setEditModalShow(false); }}
        onSaveModal={() => {
          handleEditEventForm();
          setEditModalShow(false);
        }}
        alignToCentre
        disableSaveBtn={false}
        disableCloseBtn={false}
        type="warning"
      />
    </>
  );
};

export default EventModals;
